// extracted by mini-css-extract-plugin
export default {"msg":"BibliothequePlotly_msg__upxzV","graphMain":"BibliothequePlotly_graphMain__Ag8zm"};